import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { ArcaHttpSystem } from '../code/ArcaHttpSystem.js';
import { ArcaSecurity } from '../code/ArcaSecurity.js';
import { ArcaRedirect } from '../code/ArcaRedirect.js';
import { MainMenuDropdown } from './controls/Navigation/MainMenuDropdown.jsx';
import { ArcaLogoHeader } from './controls/ReactIcons/ArcaLogoHeader.js';
import './NavMenu.css';
import { ArcaComponent } from './pages/ArcaComponent.js';

export class NavMenu extends ArcaComponent {
    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            env: null,
            menuVisible: false,
            height: this.setImageWidth(),
            smallScreen: window.innerWidth <= ArcaHttpSystem.ThresholdWidth
        };

        ArcaHttpSystem.GetAsync(
            ((env) => this.setState({ env: env }))/*.bind(this)*/,
            (() => this.setState({ env: "env: failed" }))/*.bind(this)*/);
    }

    resize() {
        let smallScreen = (window.innerWidth <= ArcaHttpSystem.ThresholdWidth);
        if (smallScreen !== this.state.smallScreen) {
            this.setState({
                height: this.setImageWidth(),
                smallScreen
            });
        }
    }

    setImageWidth() {
        return ArcaHttpSystem.IsSmartphone ? '100px' : '140px';
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    gotoLogin(env) {
        ArcaSecurity.Logoff();
        this.setState({ env: env });
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {

        let env = this.state.env === 'live' ? '' : this.state.env;
        let { height } = this.state;

        return (
            <Container className='header'>
                <Row style={{ 'marginRight' : '0px' }}>
                    <Col xs={ArcaHttpSystem.IsSmartphone ? '4' : '4'}>
                        {env}
                    </Col>
                    <Col xs={ArcaHttpSystem.IsSmartphone ? '4' : '4'}>
                        <div className='logoLink' onClick={(() => ArcaRedirect.Push('/'))} >
                            <ArcaLogoHeader height={height} isAtTop={this.props.isAtTop} />
                        </div>
                    </Col>
                    <Col xs={ArcaHttpSystem.IsSmartphone ? '4' : '4'}>
                        <MainMenuDropdown />
                    </Col>
                </Row>
            </Container>
        );
    }
}

